import { noop } from 'lodash-es';
import { useIoContext, useStoreActions, useStoreStatic } from '~/contexts';
import { useEventReporter } from '~/event-reporter/EventReporter';
export const useUserInitiatedLogout = ()=>{
    const { reset } = useStoreActions();
    const { getState } = useStoreStatic();
    const { native, getNow } = useIoContext();
    const { sendEventToGtm } = useEventReporter();
    async function logOutUser() {
        sendEventToGtm('logout', {});
        await queuePushRemoval().catch(noop);
        await native.session.setJustLoggedOut();
        reset(true);
    }
    async function queuePushRemoval() {
        var _getState_claims;
        const registration = await native.pushRegistration.recall();
        if (registration != null && registration.email === ((_getState_claims = getState().claims) === null || _getState_claims === void 0 ? void 0 : _getState_claims.email)) {
            await native.pushRemovalOutbox.put(registration.pushToken, registration.userId, getNow());
            await native.pushRegistration.forget();
        }
    }
    return {
        logOutUser
    };
};
